import { useState } from 'react';
import PropTypes from 'prop-types';
import { ChevronDown } from 'lucide-react';

import { cn } from '#/lib/utils';

import StockIssueLinesTable from './StockIssueLinesTable';

const StockIssueDetailSection = ({
  detail,
  defaultOpen = true,
  embedded = false,
}) => {
  const [open, setOpen] = useState(defaultOpen);
  const issueNo = detail?.issueNo || '-';
  const lines = detail?.lines ?? [];

  const linesTable = (
    <StockIssueLinesTable lines={lines} status={detail?.status} />
  );

  const sectionHeader = (
    <div
      className={cn(
        'flex items-center justify-between gap-3 px-4 py-3',
        embedded && 'border-t border-slate-200',
        open && 'bg-slate-50',
        embedded && !open && 'rounded-b-2xl',
        !embedded && (open ? 'rounded-t-2xl' : 'rounded-2xl'),
      )}
    >
      <button
        type="button"
        className="
          flex min-w-0 flex-1 items-center gap-3 text-left transition-colors
          hover:text-primary-600
        "
        aria-expanded={open}
        onClick={() => setOpen((prev) => !prev)}
      >
        <ChevronDown
          size={18}
          className={cn(
            'shortcut_transition-transform shrink-0 origin-center text-gray-600',
            open ? 'rotate-0' : '-rotate-90',
          )}
        />
        <div className="min-w-0 flex-1">
          <h2 className="text-base font-semibold text-gray-800">出庫明細</h2>
          <p className="truncate text-sm text-gray-500">{issueNo}</p>
        </div>
      </button>
    </div>
  );

  const sectionBody = (
    <div
      className={cn(
        'grid shortcut_transition-disclosure',
        open ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]',
      )}
      aria-hidden={!open}
    >
      <div className="min-h-0 overflow-hidden rounded-b-2xl">
        <div className="stock-receipt-detail-section__scroll">
          {linesTable}
        </div>
      </div>
    </div>
  );

  if (embedded) {
    return (
      <>
        {sectionHeader}
        {sectionBody}
      </>
    );
  }

  return (
    <div className="receipt-card-elevate">
      <div className="receipt-card-surface">
        {sectionHeader}
        {sectionBody}
      </div>
    </div>
  );
};

StockIssueDetailSection.propTypes = {
  detail: PropTypes.shape({
    issueNo: PropTypes.string,
    status: PropTypes.string,
    lines: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  defaultOpen: PropTypes.bool,
  embedded: PropTypes.bool,
};

export default StockIssueDetailSection;
